import React from "react";
import { observer } from "mobx-react-lite";
import PopupsManager from "react-sdk/PopupsManager";
import AppState, { POPUPS } from '@/js/AppState';

import PopupChapterEnd from './PopupChapterEnd/PopupChapterEnd';
import PopupFTUE from './PopupFTUE/PopupFTUE';
import PopupImgFullScreen from './PopupImgFullScreen/PopupImgFullScreen';
import PopupMinigameIntro from './PopupMinigameIntro/PopupMinigameIntro';
import PopupMinigameSequence from './PopupMinigameSequence/PopupMinigameSequence';
import PopupMinigameStars from './PopupMinigameStars/PopupMinigameStars';
import PopupPlaceholder from './PopupPlaceholder/PopupPlaceholder';
import PopupRecommandations from './PopupRecommandations/PopupRecommandations';
import Slides from "./Slides/Slides";
import Minigames from "@/js/Minigames/Minigames";
import PopupLeaderboard from "./PopupLeaderboard/PopupLeaderboard";


const Popups = () => {
  return (
    <>
      {PopupsManager.isOpened(POPUPS.MINIGAME_STARS) && <PopupMinigameStars />}
      {PopupsManager.isOpened(POPUPS.CHAPTER_END) && <PopupChapterEnd />}
      {PopupsManager.isOpened(POPUPS.MINIGAME_INTRO) && <PopupMinigameIntro />}
      {PopupsManager.isOpened(POPUPS.FTUE) && <PopupFTUE />}
      {PopupsManager.isOpened(POPUPS.IMG_FS) && <PopupImgFullScreen />}
      {PopupsManager.isOpened(POPUPS.PLACEHOLDER) && <PopupPlaceholder />}
      {PopupsManager.isOpened(POPUPS.RECOMMANDATIONS) && <PopupRecommandations />}
      {PopupsManager.isOpened(POPUPS.SLIDES) && <Slides />}
      {PopupsManager.isOpened(POPUPS.LEADERBOARD) && <PopupLeaderboard />}

      {Minigames.current && <PopupMinigameSequence />}

    </>
  )
}

export default observer(Popups)